import {element_closest, on_window_load, set_styles, unique_id} from 'lib/utilities';

export default function init_object_fit_polyfill() {
    if ('objectFit' in document.documentElement.style) {
        return;
    }

    console.log('Initialising polyfill for object-fit');

    on_window_load().then(() => {
        polyfill();
    });
}

function polyfill() {
    const images = document.querySelectorAll<HTMLImageElement>('.object-fit-fallback img');

    for (const image of images) {
        if (! image.classList.contains('is-object-fit-polyfill')) {
            polyfillImage(image);
        }
    }
}

function addBackgroundImage(id: string, url: string, fit: string, position: string) {
    const style = document.createElement('style');

    style.innerHTML = `
        *[data-ofp="${id}"] {
            background-image: url("${url}");
            background-size: ${fit};
            background-position: ${position};
        }
    `;

    document.head.appendChild(style);
}

async function polyfillImage(image: HTMLImageElement) {
    const style = getComputedStyle(image);
    const src = image.dataset.src || image.src;
    const fallback = element_closest(image, '.object-fit-fallback');

    // The computed style will retain the literal value of unsupported CSS properties
    if (fallback && src) {
        const id = `ofp-${unique_id()}`;

        fallback.setAttribute('data-ofp', id);

        addBackgroundImage(id, src, style['object-fit'] ?? 'cover', style['object-position'] ?? 'center center');

        set_styles(image, {
            visibility: 'hidden',
            opacity: '0'
        }, 'important');

        image.classList.add('is-object-fit-polyfill');
    }
}